import fetch from 'utils/fetch'

export const getAppList = params => {
    return fetch({
        url: '/app/list',
        data: params,
    })
}

export const getAppListParams = (originParams = {}) => {
    const { filterText } = originParams
    const params = {}
    if (filterText) {
        // if (/^\d+$/.test(filterText)) {
        // params['open_appid'] = filterText
        // } else {
        params['name'] = filterText
        // }
    }
    return params
}

export default {
    getAppList,
    getAppListParams,
}
